var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),(_vm.$route.name == 'invoiceContainer')?[(_vm.ready === false)?_c('v-container',{staticClass:"container--narrow"},[_c('Spinner')],1):_c('v-container',{staticClass:"container--narrow"},[_c('InvoiceList',{attrs:{"items":_vm.items}})],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }